import { defineComponent as _defineComponent } from 'vue'
import Panel from '@/client/components/_atoms/Panel.vue'
import FormItemLabel from '@/client/components/_molecules/FormItemLabel.vue'
import {
  InstagramInstantwinPretestExpirationMinutes,
  InstagramInstantwinPretestLotteryResult
} from '@/typings/api/instagram_instantwin_pretest_entry_codes.schema'

import {
  INSTAGRAM_DM_TEST_EXPIRATION_OPTIONS,
  INSTAGRAM_DM_TEST_LOTTERY_RESULT_OPTIONS
} from '../../utils/instagramDmTest'

interface Props {
  lotteryResult: InstagramInstantwinPretestLotteryResult
  expirationMinutes: InstagramInstantwinPretestExpirationMinutes
  buttonLabel: string
  loading: boolean
  disabled: boolean
}

interface Emits {
  (e: 'update:lottery-result', value: InstagramInstantwinPretestLotteryResult): void
  (e: 'update:expiration-minutes', value: InstagramInstantwinPretestExpirationMinutes): void
  (e: 'issue'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'InstagramDmTestIssueForm',
  props: {
    lotteryResult: null,
    expirationMinutes: null,
    buttonLabel: null,
    loading: { type: Boolean },
    disabled: { type: Boolean }
  },
  emits: ["update:lottery-result", "update:expiration-minutes", "issue"],
  setup(__props: any) {




return { __sfc: true,Panel, FormItemLabel, INSTAGRAM_DM_TEST_EXPIRATION_OPTIONS, INSTAGRAM_DM_TEST_LOTTERY_RESULT_OPTIONS }
}

})